/**
 * Entry point. Mounts React, imports the global stylesheet (which pulls in the
 * Meridian tokens), and wires the query client's 401 handler to a hard redirect
 * to the BFF login — so an expired session anywhere in the app ends cleanly.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { setUnauthorizedHandler } from "@/lib/queryClient";
import "@/styles/global.css";

// On any 401 from a query/mutation, end the session at the BFF. Guard against a
// redirect loop when we're already on the login route.
setUnauthorizedHandler(() => {
  if (!window.location.pathname.startsWith("/login")) {
    window.location.assign("/auth/login");
  }
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
